import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import UiContent from "../../Components/Common/UiContent";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import FlipFlashCard from "./FlipFlashCard";
import { useHistory } from "react-router-dom";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { useSelector } from "react-redux";
import CustomPagination from "../../Components/Common/CustomPagination";
import Loader from "../../Components/Common/Loader";
import AssignServersModal from "./AssignServersModal";
import { exportFlashCardsToPDF } from "./exportFlashCardsPDF";

const FlashCards = () => {
    const history = useHistory();
    const [flashcards, setFlashcards] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [selectedPage, setSelectedPage] = useState(0);
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [selectedCard, setSelectedCard] = useState(null);
    const [downloadingAll, setDownloadingAll] = useState(false);


  const { currentOutlet } = useSelector((state) => ({
        currentOutlet: state.UserOutletGroup.currentOutlet
  }));

  const controllerRef = useRef(null);
  useEffect(() => {
    fetchMenuItems();
    return () => {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
    };
  }, [currentOutlet, selectedPage]);

  const fetchMenuItems = () => {
    
    // cancel previous request
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    const controller = new AbortController();
    controllerRef.current = controller;
    setLoading(true);
      postDataAPI({
        serviceName: "item_data",
        op: "server_coaching_outlet_items",
        display_classcification: "Yes",
        type: "Flash",
        status: "Active",
        load: selectedPage+1,
        is_show_all: false,
        course_id: "",
        flash_status: "Complete"
      }, controller.signal)
        .then((res) => {
          if (res.status === "ok") {
            setFlashcards(res.data.server_data || []);
            setPageCount(Math.ceil(parseInt(res.data.total_records) / 9));
          }
        }).catch((err) => {
        if (err.code === "ERR_CANCELED") {
          console.log("Request cancelled");
          return;
        }
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
    
  };

  const handleDeleteFlashcard = (card) => {
    if (!window.confirm(`Delete "${card.item_name}" flashcard?`)) return;

    postDataAPI({
      serviceName: "item_data",
      op: "server_coaching_delete_flash_card",
      flash_id: card.flash_id
    }).then((res) => {
      if (res.status === "ok") {
        fetchMenuItems(); // refresh list
      } else {
        alert(res.message || "Failed to delete flashcard");
      }
    });
  };

  const handleDownloadAll = async () => {
    setDownloadingAll(true);
    try {
      const res = await postDataAPI({
        serviceName: "item_data",
        op: "fetch_all_flash_cards_detail_data",
        selectedOutletID: currentOutlet?.id
      });

      if (res.status !== "ok") {
        alert(res.message || "Failed to fetch flashcards for download");
        return;
      }

      const cards = Array.isArray(res.data) ? res.data : [];
      if (!cards.length) {
        alert("No flashcards found to download");
        return;
      }

      const outletLabel = (currentOutlet?.name || currentOutlet?.outlet_name || "Outlet")
        .toString()
        .replace(/[^\w\- ]+/g, "")
        .trim()
        .replace(/\s+/g, "_");
      const fileName = `FlashCards_${outletLabel || "All"}.pdf`;

      await exportFlashCardsToPDF(cards, fileName);
    } catch (err) {
      console.error(err);
      alert("Failed to generate flashcards PDF. Please try again.");
    } finally {
      setDownloadingAll(false);
    }
  };

  return (
    <React.Fragment>
    <UiContent />
    <div className="page-content">
      <Container fluid>
        {loading && <Loader />}
        <BreadCrumb title="Flash Cards" pageTitle="Dashboard &nbsp; > &nbsp; Server Performance Coaching" />
        <Row className="align-items-center mb-4">
          <Col className="text-end">
          <Button outline className="me-2"
                onClick={() => history.push("/server-performance-coaching")}
            >
                ⬅ Back to Home
            </Button>
            <Button
              color="primary"
              onClick={handleDownloadAll}
              disabled={downloadingAll}
            >
              {downloadingAll ? "Downloading..." : "Download All"}
            </Button>
          </Col>
        </Row>
        <Row className="g-4">
          {flashcards.map(card => (
            <Col key={card.item_id} sm="6" md="3" lg="4">
              <FlipFlashCard
                card={card}
                onAssign={() => {
                  setSelectedCard(card);
                  setShowAssignModal(true);
                }}
                refreshCards={fetchMenuItems}
                onDelete={() => handleDeleteFlashcard(card)}
              />

            </Col>
          ))}
          <CustomPagination
            pageCount={pageCount}
            setSelectedPage={setSelectedPage}
          />
        </Row>

        {showAssignModal && (
          <AssignServersModal
            isOpen={showAssignModal}
            toggle={() => setShowAssignModal(false)}
            card={selectedCard}
          />
        )}

      </Container>
      </div>
    </React.Fragment>
  );
};

export default FlashCards;
